import { useCallback } from 'react';
import styles from './FlagCheckbox.module.css';

interface FlagCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  variant?: 'success' | 'warning' | 'default';
  disabled?: boolean;
  title?: string;
}

export default function FlagCheckbox({
  label,
  checked,
  onChange,
  variant = 'default',
  disabled = false,
  title,
}: FlagCheckboxProps) {
  const handleChange = useCallback(() => {
    if (!disabled) {
      onChange(!checked);
    }
  }, [checked, onChange, disabled]);

  const boxClass = [
    styles.box,
    checked && variant === 'success' && styles.boxCheckedSuccess,
    checked && variant === 'warning' && styles.boxCheckedWarning,
    checked && variant === 'default' && styles.boxCheckedDefault,
  ]
    .filter(Boolean)
    .join(' ');

  const labelClass = [
    styles.label,
    checked && variant === 'success' && styles.labelCheckedSuccess,
    checked && variant === 'warning' && styles.labelCheckedWarning,
    checked && variant === 'default' && styles.labelCheckedDefault,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label
      className={`${styles.checkbox} ${disabled ? styles.checkboxDisabled : ''}`}
      title={title}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={styles.hiddenInput}
      />
      <span className={boxClass}>
        {checked && <span className={styles.checkmark}>&#x2713;</span>}
      </span>
      <span className={labelClass}>{label}</span>
    </label>
  );
}
